import { render, staticRenderFns } from "./node-context-menu.vue?vue&type=template&id=fb0baf1e&"
import script from "./node-context-menu.vue?vue&type=script&lang=ts&"
export * from "./node-context-menu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports